import './structureDataSource.css'

import React from 'react'
import { formatDate, formatTime } from 'utils'

import Box from '@mui/material/Box'

interface DateTimeCellProps {
  datetime?: string | null
  isCumulative: boolean
}

export default function DateTimeCell({ datetime, isCumulative }: DateTimeCellProps) {
  return (
    <Box>
      <Box>{formatTime(datetime)}</Box>
      {isCumulative && <Box>{formatDate(datetime)}</Box>}
    </Box>
  )
}
